/*
 * @Author: your name
 * @Date: 2021-05-24 16:21:17
 * @LastEditTime: 2021-05-24 16:21:25
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \dtpWeb\src\assets\js\bus.js
 */
import Vue from 'vue'
const bus = new Vue()
export default bus
